export const SHARED_ROUTES = {
  home: '/',

  //login
  login: '/auth/login',
  login_via_params: '/auth/login/via-params', //login when admin visits platform directly and window.opener is undefined

  //register user
  signup: '/auth/signup/user-type-select',
  signupCreatePassword: '/auth/create-password',
  signup_userDetail: '/auth/signup/user-details',
  signup_email_sent: '/auth/signup/email-sent',
  signup_verification: '/auth/signup/verification',
  signup_subscription_paywall: '/auth/signup/subscription-paywall',
  signup_stripe_payment: '/auth/signup/stripe-payment',
  signup_payment_method: '/auth/signup/payment-method',
  signup_welcomeBack: '/auth/signup/welcome-back',
  signup_trial: '/auth/signup/trial',
  signup_organizationQuestions: '/auth/signup/organization-questions',
  expired_subscription: '/auth/expired-subscription',
  //forgot password
  forgotPassword: '/auth/forgot-password',
  resetPassword: '/auth/forgot-password/reset',
  passwordChanged: '/auth/forgot-password/changed',
  changePasswordOnSignup: '/auth/signup/change-password',
  not_found: '/404',
} as const;
